import React, { useState, useEffect } from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import InputWithHelp from './InputWithHelp'
import CDropdown from './CDropdown'
import { TimeUtils } from '../utils/timeHelpers'

interface TimeoutInputProps {
    label: string
    helpText: string
    value?: number // Value in seconds
    onChange: (seconds: number) => void
    error?: string
    disabled?: boolean
    placeholder?: string
}

const timeUnits = ['seconds', 'minutes', 'hours', 'days']

const TimeoutInput: React.FC<TimeoutInputProps> = ({ 
    label, 
    helpText, 
    value = 0, 
    onChange, 
    error, 
    disabled = false,
    placeholder
}) => {
    const [inputValue, setInputValue] = useState('')
    const [selectedUnit, setSelectedUnit] = useState('minutes')

    // Initialize from value prop
    useEffect(() => {
        if (value > 0) {
            const { value: convertedValue, unit } = TimeUtils.secondsToUnit(value)
            setInputValue(convertedValue.toString())
            setSelectedUnit(unit)
        } else {
            setInputValue('')
        }
    }, [value])

    const handleValueChange = (newValue: string) => {
        setInputValue(newValue)
        const numValue = parseFloat(newValue)
        if (!isNaN(numValue) && numValue > 0) {
            const seconds = TimeUtils.convertToSeconds(numValue, selectedUnit as any)
            onChange(seconds)
        } else if (newValue === '') {
            onChange(0)
        }
    }

    const handleUnitChange = (unit: string) => {
        setSelectedUnit(unit)
        const numValue = parseFloat(inputValue)
        if (!isNaN(numValue) && numValue > 0) {
            const seconds = TimeUtils.convertToSeconds(numValue, unit as any)
            onChange(seconds)
        }
    }

    return (
        <div>
            <Row>
                <Col>
                    <InputWithHelp
                        label={label}
                        helpText={helpText}
                        type="number"
                        min="1"
                        step="1"
                        value={inputValue}
                        onChange={(e: any) => handleValueChange(e.target.value)}
                        error={!!error}
                        errorMessage={error}
                        disabled={disabled}
                        placeholder={placeholder}
                        className="form-control modal-input"
                    />
                </Col>
                <Col xs="auto" style={{ minWidth: '120px' }}>
                    <div style={{ marginTop: label ? '28px' : '0' }}>
                        <CDropdown
                            selected={timeUnits.findIndex(unit => unit === selectedUnit)}
                            items={timeUnits}
                            onSelected={(selectedKey) => selectedKey && !disabled && handleUnitChange(selectedKey)}
                        />
                    </div>
                </Col>
            </Row>
            {value > 0 && (
                <small className="text-muted" style={{ fontSize: '11px' }}>
                    = {TimeUtils.secondsToHumanReadable(value)}
                </small>
            )}
        </div>
    )
}

export default TimeoutInput